import React, {Component} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ShoreTypeSelecter from "./ShoreTypeSelecter";
import ShoreSelecter from "./ShoreSelecter";
import ShoreConnSelecter from "./ShoreConnSelecter";
import {AlertModal, helper}  from "./../app.js"; 

export default class ShoreConfigurator extends Component 
{
    prevSectCnt = 0;
    prevTrayLength = 0;
    //stepWarningShowed = false;

    constructor (props)
    {
        super(props);

        this.state = {            
            shore_filter: this.props?.shore_filter ?? {type: '', is_unitary: true, carrier_type: ''}, 
            shore_stud: this.props?.shore_stud,
            shore_stud_conns: this.props?.shore_stud_conns, // крепеж стоек между собой 
            shore_stud_shelf_conns: this.props?.shore_stud_shelf_conns, // крепеж стоек и полок            
            shore_stud_add: this.props?.shore_stud_add,
            shore_stud_add_conns: this.props?.shore_stud_add_conns, // крепеж доп. элементов к стойке
            shore_shelf: this.props?.shore_shelf,
            shore_shelf_conns: this.props?.shore_shelf_conns, // крепеж полок с лотком
            shore_connector: this.props?.shore_connector, // крепеж стоек и несущей
            step: this.props?.shore_step,
            sect_count: this.props?.shore_sect_count,
            alert_message: ''
        };
        this.prevSectCnt = this.state.sect_count;
        this.prevTrayLength = this.props.tray_length;

        this.processSelected = this.processSelected.bind(this);
        this.setStep = this.setStep.bind(this);
        this.setQuantity = this.setQuantity.bind(this);
        //this.quantityBlurHandler = this.quantityBlurHandler.bind(this);
    }
    getShoreFilterKey (shore_filter)
    {
        return `ss_${this.props.tray_articul}_${shore_filter.type}_${shore_filter.carrier_type}_${shore_filter.is_unitary}`;
    }
    processSelected (item, type, showInfo = true)
    {
        if (type in this.state)
        {
            const newState = {[type]: item};

            switch (type)
            {
                case 'shore_filter':

                    if (this.getShoreFilterKey(item) !== this.getShoreFilterKey(this.state.shore_filter))
                    {
                        this.setState(
                        {
                            shore_filter: item,
                            shore_stud: null,
                            shore_stud_conns: null,
                            shore_stud_shelf_conns: null,
                            shore_stud_add: null,
                            shore_stud_add_conns: null,
                            shore_shelf: null,
                            shore_shelf_conns: null,
                            shore_connector: null,
                            step: '',
                            sect_count: 0
                        });
                    }
                    break;

                case 'shore_shelf':
                case 'shore_stud':

                    const isUnitary = this.state.shore_filter.is_unitary;

                    if (null === item && ('shore_stud' == type || isUnitary))
                    {
                        this.setState(
                        {
                            shore_stud: null,
                            shore_stud_conns: null,
                            shore_stud_shelf_conns: null,
                            shore_stud_add: null,
                            shore_stud_add_conns: null,
                            shore_shelf: null,
                            shore_shelf_conns: null,
                            shore_connector: null,
                            step: '',
                            sect_count: 0
                        });
                    }
                    else if ('shore_stud' == type)
                    {
                        if (!this.state.shore_stud || item.id != this.state.shore_stud.id)
                        {
                            this.setState(
                            {
                                shore_stud: item,
                                shore_stud_conns: null,
                                shore_stud_shelf_conns: null,
                                shore_stud_add: null,
                                shore_stud_add_conns: null,
                                shore_shelf: null,
                                shore_shelf_conns: null,
                                shore_connector: null,
                                step: '',
                                sect_count: 0
                            });
                        }
                        else
                            this.setState(newState);
                    }
                    else if (isUnitary) 
                    {
                        if (!this.state.shore_shelf || item.id != this.state.shore_shelf.id)
                        {
                            this.setState(
                            {
                                shore_stud: null,
                                shore_stud_conns: null,
                                shore_stud_shelf_conns: null,
                                shore_stud_add: null,
                                shore_stud_add_conns: null,
                                shore_shelf: item,
                                shore_shelf_conns: null,
                                shore_connector: null,
                                step: '',
                                sect_count: 0
                            });
                        }
                        else
                            this.setState(newState);
                    }
                    else
                        this.setState(newState);

                    this.props.on_select_item(item, 'info', showInfo);
                    break;

                case 'shore_stud_add':

                    this.setState(state => 
                    {   
                        state.shore_stud_add = item;
                        this.calcStudAdd();
                    });
                    this.props.on_select_item(item, 'info', showInfo);
                    break;

                case 'shore_stud_add_conns':

                    this.setState(state => 
                    {   
                        state.shore_stud_add_conns = item;
                        this.calcStudAddConns();
                    });
                    break;

                case 'shore_connector':

                    this.setState(state => 
                    {   
                        state.shore_connector = item;
                        this.calcShoreConnector();
                    });
                    break;
                /*
                case 'shore_shelf_conns':

                    console.log('shore_shelf_conns', newState);

                    this.setState(newState);

                    this.props.on_select_item(item, 'info', showInfo);
                    break;*/

                default:

                    this.setState(newState);

                    this.props.on_select_item(item, 'info', showInfo);
                    break;
            }
        }
    }    
    setStep (e)
    {
        const stepValue = e.target.value.trim(),
            step = parseFloat(stepValue);

        if ('' !== stepValue)
        {
            if (/^\d+\.?\d*$/.test(stepValue))
            {
                if ('.' != stepValue.slice(-1))
                {
                    if (0 == step)
                    {
                        this.setState({step: '0'});
                    }
                    else if (step >= 0.01)
                    {
                        this.calcQuantities(step, this.state.shore_stud, this.state.shore_shelf);
                    }
                    else
                        this.setState({step: ''});
                }
                else
                    this.setState({step: stepValue});
            }
            else
                this.setState({alert_message: 'Некорректное значение шага подвесов'});
        }
        else
            this.setState({step: ''});
    }
    setQuantity (e) 
    {
        const step = this.state.step;        
        let sect_count = e.target.value.trim();

        if (!step) 
        {
            this.setState({alert_message: 'Не задан шаг подвесов'});
        }
        else 
        {
            if ('' !== sect_count)
            {
                sect_count = parseInt(sect_count);

                if (isNaN(sect_count) || sect_count < 0)
                {
                    this.setState({alert_message: 'Некорректное значение количества подвесов'});
                }
                else if (!sect_count) 
                {
                    this.setState({alert_message: 'Не задано количество подвесов'});
                }
                else 
                {
                    this.calcQuantities(this.state.step, this.state.shore_stud, this.state.shore_shelf, sect_count);                    
                    //this.setState({sect_count});
                } 
            }
            else
                this.setState({sect_count: ''}); 
        } 
    }
    calcQuantities (step, stud = null, shelf = null, sect_count = 0)
    {   
        if ((step || sect_count) && !helper.isNotObjectOrEmpty(shelf))
        {
            if (!sect_count) sect_count = Math.ceil(this.props.tray_length / (step * 1000));

            const newState = {step, sect_count},
                levelsCnt = 1;

            //console.log('calcQuantities, before', newState, shelf, stud);

            shelf.quantity = 'use_length' in shelf && shelf.use_length
                                ? Math.ceil(levelsCnt * sect_count / Math.floor(shelf.length / shelf.use_length))
                                : Math.ceil(levelsCnt * sect_count / Math.floor(shelf.length / (this.props.tray_width + 50)));

            //console.log(`shelf, ${shelf.use_length}, sect_count ${sect_count}, length ${shelf.length}, use_length ${shelf.use_length}, tray_width ${this.props.tray_width}, quantity ${shelf.quantity}`);

            if (!shelf.quantity || Infinity === shelf.quantity) shelf.quantity = sect_count;

            if (!helper.isNotObjectOrEmpty(stud))
            {                    
                if (!('use_length' in stud) || !stud.use_length) stud.use_length = stud.length;

                stud.quantity = stud.length >= stud.use_length
                                    ? Math.ceil(shelf.sect_studs_cnt * sect_count / Math.floor(stud.length / stud.use_length))
                                    : Math.ceil(shelf.sect_studs_cnt * sect_count * (stud.use_length / stud.length));

                //console.log(`stud, ${stud.use_length}, sect_studs_cnt ${shelf.sect_studs_cnt}, length ${stud.length}, use_length ${stud.use_length}, quantity ${stud.quantity}`);

                if (!stud.quantity || Infinity === stud.quantity) stud.quantity = sect_count;

                newState.shore_stud = stud;
            }
            
            newState.shore_shelf = shelf;

            //console.log('calcQuantities, after', newState);

            this.setState(newState);
        }        
    
    }
    calcStudAdd ()
    {
        const sectCnt = this.state.sect_count,
            stud = this.state.shore_stud,
            studAdd = helper.copyObject(this.state.shore_stud_add);

        if (sectCnt && !helper.isNotObjectOrEmpty(stud) && !helper.isNotObjectOrEmpty(studAdd))
        {
            studAdd.quantity = studAdd.quantity_multiple * stud.quantity;
            this.props.on_select_item(studAdd, 'shore_stud_add', false);
            //console.log('studAdd', studAdd);

            this.calcStudAddConns();
        }
        else
        {
            this.props.on_select_item(null, 'shore_stud_add', false);
            this.props.on_select_item(null, 'shore_stud_add_conns', false);
        }
    }
    calcStudAddConns ()
    {
        const sectCnt = this.state.sect_count,
            stud = this.state.shore_stud,
            studAdd = helper.copyObject(this.state.shore_stud_add),
            studAddConns_ = this.state.shore_stud_add_conns;

        //console.log(sectCnt, studAdd, studAddConns_);

        if (sectCnt && !helper.isNotObjectOrEmpty(stud) && !helper.isNotObjectOrEmpty(studAdd) && !helper.isNotObjectOrEmpty(studAddConns_))
        {
            const studAddConns = {name: 'Соединители стоек с допэлементами', products: []};

            studAdd.quantity = studAdd.quantity_multiple * stud.quantity;

            Object.keys(studAddConns_).forEach(k => 
            {
                let studAddConn = studAddConns_[k];

                if (!helper.isNotObjectOrEmpty(studAddConn))
                {
                    studAddConn = helper.copyObject(studAddConn);
                    studAddConn.quantity = studAddConn.count * studAdd.quantity;
                    studAddConns.products.push(studAddConn);
                }
            });
            this.props.on_select_item(studAddConns, 'shore_stud_add_conns', false);  
            //console.log('studAddConns', studAddConns);
        }
        else
            this.props.on_select_item(null, 'shore_stud_add_conns', false);
    }
    calcShoreConnector ()
    {
        const sectCnt = this.state.sect_count,
            shoreConnector = helper.copyObject(this.state.shore_connector);

        //console.log('shoreConnector', shoreConnector);

        if (sectCnt && !helper.isNotObjectOrEmpty(shoreConnector))
        {
            if ('products' in shoreConnector)
            {
                let connectors = [];
                shoreConnector.products.forEach(connector =>
                {
                    connector = helper.copyObject(connector);
                    connector.quantity = connector.count * sectCnt;
                    connectors.push(connector);
                });
                shoreConnector.products = connectors;
            }
            else
            {
                shoreConnector.quantity = shoreConnector.count * sectCnt;
            }
            this.props.on_select_item(shoreConnector, 'shore_connector', false);
            //console.log('componentDidUpdate, shore_connector', shore_connector);             
        }
        else
            this.props.on_select_item(null, 'shore_connector', false);
    }
    calcShoreItems ()
    {
        const sectCnt = this.state.sect_count;

        //console.log('calcShoreItems', this.state);

        if (sectCnt)
        {
            this.props.on_select_item(this.state.shore_filter, 'shore_filter', false);
            this.props.on_select_item(this.state.step, 'shore_step', false);
            this.props.on_select_item(sectCnt, 'shore_sect_count', false);

            //console.log('this.state.shore_filter', this.state.shore_filter);

            if (!helper.isNotObjectOrEmpty(this.state.shore_stud))
            {
                const stud = helper.copyObject(this.state.shore_stud);
                //stud.quantity *= sectCnt; 
                this.props.on_select_item(stud, 'shore_stud', false);
                //console.log('componentDidUpdate, stud', stud);

                if (!helper.isNotObjectOrEmpty(this.state.shore_stud_conns))
                {
                    const stud_conns = {name: 'Соединители стоек между собой', products: []}; 
                    Object.keys(this.state.shore_stud_conns).forEach(k => 
                    {
                        let stud_conn = this.state.shore_stud_conns[k];

                        if (!helper.isNotObjectOrEmpty(stud_conn))
                        {
                            stud_conn = helper.copyObject(stud_conn);
                            stud_conn.quantity = stud_conn.count * stud.quantity;
                            stud_conns.products.push(stud_conn);
                        }
                    });
                    this.props.on_select_item(stud_conns, 'shore_stud_conns', false);   
                    //console.log('componentDidUpdate, stud_conns', stud_conns);
                }

                this.calcStudAdd();
            }

            if (!helper.isNotObjectOrEmpty(this.state.shore_shelf))
            {
                const shelf = helper.copyObject(this.state.shore_shelf);
                //shelf.quantity *= sectCnt;
                this.props.on_select_item(shelf, 'shore_shelf', false);
                //console.log('componentDidUpdate, shelf', shelf);

                if (!helper.isNotObjectOrEmpty(this.state.shore_shelf_conns)) 
                {
                    const shelfConns = {name: 'Соединители лотков и полок', products: []};
                    Object.keys(this.state.shore_shelf_conns).forEach(k => 
                    {
                        const shelfConn = helper.copyObject(this.state.shore_shelf_conns[k]);

                        //console.log('componentDidUpdate, shelf_conns', shelfConn);

                        if (!helper.isNotObjectOrEmpty(shelfConn))
                        {
                            shelfConn.quantity = shelfConn.count * sectCnt;
                            shelfConns.products.push(shelfConn);
                        }
                    });
                    this.props.on_select_item(shelfConns, 'shore_shelf_conns', false);
                    //console.log('componentDidUpdate, shelf_conns', shelfConns);
                    //debugger;
                } 

                if (!helper.isNotObjectOrEmpty(this.state.shore_stud_shelf_conns))
                {
                    const stud_shelf_conns = {name: 'Соединители стоек и полок', products: []};
                    Object.keys(this.state.shore_stud_shelf_conns).forEach(k => 
                    {
                        let stud_shelf_conn = this.state.shore_stud_shelf_conns[k];

                        if (!helper.isNotObjectOrEmpty(stud_shelf_conn))
                        {
                            stud_shelf_conn = helper.copyObject(stud_shelf_conn);
                            stud_shelf_conn.quantity = stud_shelf_conn.count * sectCnt;
                            stud_shelf_conns.products.push(stud_shelf_conn);
                        }
                    });
                    this.props.on_select_item(stud_shelf_conns, 'shore_stud_shelf_conns', false);   
                    //console.log('componentDidUpdate, stud_shelf_conns', stud_shelf_conns);             
                }  
            }
            
            this.calcShoreConnector();
        }
        else
        {
            this.props.on_select_item({type: '', is_unitary: true, carrier_type: ''}, 'shore_filter', false);
            this.props.on_select_item(null, 'shore_stud', false); // @todo мб будет достаточно один отправить, как tray=null у лотков? 
            this.props.on_select_item(null, 'shore_stud_conns', false);
            this.props.on_select_item(null, 'shore_stud_add', false);
            this.props.on_select_item(null, 'shore_stud_add_conns', false);
            this.props.on_select_item(null, 'shore_shelf', false);
            this.props.on_select_item(null, 'shore_shelf_conns', false);
            this.props.on_select_item(null, 'shore_connector', false);
        }
    }
    componentDidUpdate () 
    {
        const sectCnt = this.state.sect_count,
            trayLength = this.props.tray_length;

        //console.log('componentDidUpdate', sectCnt, this.prevSectCnt, trayLength, this.prevTrayLength);

        if (this.prevSectCnt != sectCnt)
        {
            this.prevSectCnt = sectCnt;
            this.calcShoreItems();            
        } /*
        else if (this.prevTrayLength != trayLength)
        {
            this.prevTrayLength = trayLength;
            this.calcQuantities(this.state.step, this.state.shore_stud, this.state.shore_shelf);            
        }*/
    }
    render () 
    {
        //console.log(this.state);
        const trayType = this.props.tray_type,
            trayArticul = this.props.tray_articul,
            carrierType = this.state.shore_filter.carrier_type,
            isUnitary = this.state.shore_filter.is_unitary,
            shoreProps = {
                tray_type: trayType,
                tray_articul: trayArticul,
                shore_type: this.state.shore_filter.type, 
                carrier_type: carrierType,
                is_unitary: isUnitary,
                init_stud: this.state.shore_stud,
                init_stud_add: this.state.shore_stud_add,
                init_stud_conns: this.state.shore_stud_conns,
                init_stud_shelf_conns: this.state.shore_stud_shelf_conns,
                init_stud_add_conns: this.state.shore_stud_add_conns,
                init_shelf: this.state.shore_shelf,
                init_shelf_conns: this.state.shore_shelf_conns
            },            
            hasStud = !helper.isNotObjectOrEmpty(this.state.shore_stud),
            studArticul = hasStud ? this.state.shore_stud.articul : '',
            hasShelf = !helper.isNotObjectOrEmpty(this.state.shore_shelf),
            shelfId = hasShelf ? this.state.shore_shelf.id : '',
            shelfArticul = hasShelf ? this.state.shore_shelf.articul : '',   
            shoreKey = this.getShoreFilterKey(this.state.shore_filter),
            canInputStep = ((isUnitary && hasShelf) || (!isUnitary && hasShelf && hasStud)) && this.props.tray_length,
            canInputQuantity = canInputStep && this.state.step;

        return (<>
            <Form>
                <ShoreTypeSelecter key={`st_${trayArticul}`} on_select={this.processSelected} tray_type={trayType} tray_articul={trayArticul} init_filter={this.state.shore_filter} />
                <ShoreSelecter key={shoreKey} on_select={this.processSelected} {...shoreProps} />
                <ShoreConnSelecter key={`scon_${shelfId}`} on_select={this.processSelected} stud_articul={studArticul} 
                    shelf_articul={shelfArticul} carrier_type={carrierType} init_connector={this.state.shore_connector} />
                <Form.Row>
                    <Form.Group as={Col} sm={3}>
                        <Form.Label className={!canInputStep ? 'text-muted' : ''}>Шаг подвесов,&nbsp;м:</Form.Label>
                        <Form.Control onChange={this.setStep} value={this.state.step} disabled={!canInputStep} type="text" placeholder="Шаг подвесов, м" />
                    </Form.Group>

                    <Form.Group as={Col} sm={4}>
                        <Form.Label className={!canInputQuantity ? 'text-muted' : ''}>Кол-во подвесов,&nbsp;шт:</Form.Label>
                        <Form.Control onChange={this.setQuantity} value={this.state.sect_count} disabled={!canInputQuantity} type="text" placeholder="Кол-во подвесов, шт" />
                    </Form.Group>
                </Form.Row>
            </Form>
            <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} />
        </>);
    }
}
